export function phoneMosk(data) {
	const telphone = data.substring(0, 3) + '****' + data.substring(7);
	return telphone;
}
export function mailMosk(data) {
	if (!data) return;
	const index = data.lastIndexOf('@');
	let str = data.substring(0, index);
	const str1 = data.substring(index + 1, data.length);
	// if (str.length <= 4) {
	// 	str = str.substring(0, index - 1);
	// 	str = str + '*';
	// } else {
	// 	str = str.substring(0, 3);
	// 	str = str + '**';
	// }
	if (str.length == 1) {
		str = '*';
	} else if (str.length == 2) {
		str = str.substring(0, 1);
		str = str + '*';
	} else if (str.length == 3) {
		str = str.substring(0, 2) + '*';
	} else if (str.length == 4) {
		str = str.substring(0, 3) + '*';
	} else if (str.length == 5) {
		str = str.substring(0, 3) + '**';
	} else if (str.length == 6) {
		str =
			str.substring(0, 2) +
			'***' +
			str.substring(str.length - 1, str.length);
	} else if (str.length == 7) {
		str =
			str.substring(0, 3) +
			'***' +
			str.substring(str.length - 1, str.length);
	} else if (str.length == 8) {
		str =
			str.substring(0, 3) +
			'***' +
			str.substring(str.length - 2, str.length);
	} else if (str.length >= 9) {
		str =
			str.substring(0, 3) +
			'***' +
			str.substring(str.length - 3, str.length);
	}
	return str + '@' + str1;
}

export function nameMosk(data) {
	if (!data) return;
	let nameStr = '';
	const datalength = data.length;
	if (datalength === 1) {
		nameStr = '*';
	} else if (datalength === 2) {
		nameStr = data.substring(0, 1) + '*';
	} else if (datalength === 3) {
		nameStr = data.substring(0, 1) + '**';
	} else if (datalength === 4) {
		nameStr =
			data.substring(0, 1) +
			'**' +
			data.substring(datalength - 1, datalength);
	} else if (datalength === 5) {
		nameStr =
			data.substring(0, 1) +
			'***' +
			data.substring(datalength - 1, datalength);
	} else if (datalength === 6) {
		nameStr =
			data.substring(0, 2) +
			'***' +
			data.substring(datalength - 1, datalength);
	} else if (datalength >= 7) {
		nameStr =
			data.substring(0, 2) +
			'***' +
			data.substring(datalength - 2, datalength);
	}
	return nameStr;
}

// 判断三方登录
// 微信 --> 101// QQ  --> 102// 苹果 --> 103// FB  --> 104// 谷歌 --> 105// B站 --> 106// 微博 --> 107// line --> 108
export function getSanfLoginWay(id) {
	let imgSrc, loginName;
	const idNum = parseInt(id);
	switch (idNum) {
		case 103: //apple
			imgSrc = require('@/assets/images/apple_btn.png');
			loginName = 'Apple';
			break;
		case 104: //fb
			imgSrc = require('@/assets/images/fb_btn.png');
			loginName = 'Fackbook';
			break;
		case 105: //google
			imgSrc = require('@/assets/images/google_btn.png');
			loginName = 'Google';
			break;
		case 108: //line
			imgSrc = require('@/assets/images/line_btn.png');
			loginName = 'Line';
			break;
		case 110: //line
			imgSrc = require('@/assets/images/games_center_btn.png');
			loginName = 'GameCenter';
			break;
		case 112: //kakao
			imgSrc = require('@/assets/images/kakao.png');
			loginName = 'Kakao';
			break;
		case 113: //naver
			imgSrc = require('@/assets/images/n_btn.png');
			loginName = 'Naver';
			break;
	}
	return {
		imgSrc,
		loginName,
	};
}
